<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <b-form v-on:submit.prevent="autorizar">
      <b-table-simple class="mt-4">
        <b-thead class="columnas">
          <b-tr>
            <b-th>Precio unitario</b-th>
            <b-th>Cantidad</b-th>
            <b-th>Descripción</b-th>
            <b-th>Cantidad autorizada</b-th>
          </b-tr>
        </b-thead>
        <b-tbody>
          <b-tr v-for="(datos, index) in producto" :key="index">
            <b-td>{{ datos.precio | moneda }}</b-td>
            <b-td>{{ datos.cantidad }}</b-td>
            <b-td>{{ datos.descripcion }}</b-td>
            <b-td>{{ datos.cantidadAutorizada }}</b-td>
          </b-tr>
        </b-tbody>
      </b-table-simple>

      <div class="mt-4 text-center">
        <b-button type="submit" variant="outline-primary" v-if="!enviando">
          Autorizar
        </b-button>

        <b-button variant="primary" v-show="enviando" disabled>
          <b-spinner small></b-spinner>
          Cargando...
        </b-button>
      </div>
    </b-form>
  </div>
</template>

<script>
import VueNotifications from "vue-notifications";

export default {
  name: "Autorizar",
  props: {
    requisicion: Object,
    producto: Array,
    ordinario: Boolean,
  },
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,
    enviando: false,
  }),
  created() {
    this.debug = this.$localStorageService.getDebug();
    if (this.ordinario) {
      this.alertarRecordatorio();
    }
  },
  methods: {
    alertarRecordatorio() {
      this.$swal({
        icon: "warning",
        title: "¡Recuerda!",
        text:
          "La autorización de requisición por coordinación son los días: martes 12:00 AM a sábado 20:00 hrs",
        confirmButtonText: "OK",
        confirmButtonColor: "#0e6ba9",
      });
    },
    autorizar() {
      this.enviando = true;
      const url = this.$api + "requisiciones/estatus";
      this.$http
        .put(url, this.traerDatos())
        .then((response) => {
          if (response.status === 200) {
            this.insertarOrdenKepler();
          }
        })
        .catch((err) => {
          this.enviando = false;
          this.errorEnvio(err);
        });
    },
    traerDatos() {
      let listaProducto = [];
      this.producto.forEach((it) => {
        let elemento = {
          idRequisicionProducto: it.idRequisicionProducto,
          cantidadAutorizada: it.cantidadAutorizada,
        };
        listaProducto.push(elemento);
      });

      return {
        idRequisicion: this.requisicion.idRequisicion,
        productos: listaProducto,
        usuarioLogeado: this.$localStorageService.getIdUsuario(),
      };
    },
    insertarOrdenKepler() {
      // let peticion = this.$api + "requisiciones/kepler/orden";
      // this.$http
      //   .post(peticion, this.traerDatosKepler())
      //   .then((response) => {
      //     if (response.status === 200) {
      this.$swal({
        icon: "success",
        text: "Se envio la información correctamente",
        confirmButtonText: "OK",
        confirmButtonColor: "#0e6ba9",
      });
      setTimeout(() => location.reload(), 2000);
      this.enviando = false;
      //     }
      //   })
      //   .catch((err) => {
      //     this.enviando = false;
      //     this.errorEnvio(err);
      //   });
    },
    traerDatosKepler() {
      return {
        clinica: this.requisicion.clinica,
        numeroOrden: this.requisicion.numeroOrden,
        productos: this.producto,
        fechaAlta: this.requisicion.fechaAlta,
      };
    },
  },
  notifications: {
    errorEnvio: {
      type: VueNotifications.types.error,
      title: "Error",
      message: "Error al enviar la información",
    },
  },
};
</script>